import { addGalleryDoneTick, removeGalleryDoneTick, } from "../api/gallery/galleryCollectedPlayers";
/**
 * Flips a Done tick right away, then adds or deletes the collected player; a failed write puts the tick back unless
 * another toggle moved it since. `isTicked` must read the latest state, not a render's, so a quick double tap
 * writes add then delete. Signed out (`write` false) the tick is local only.
 */
export const toggleDoneTick = (id, isTicked, setTicked, write) => {
    const ticking = !isTicked(id);
    setTicked(id, ticking);
    if (!write)
        return;
    (ticking ? addGalleryDoneTick(id) : removeGalleryDoneTick(id)).catch(() => {
        if (isTicked(id) === ticking)
            setTicked(id, !ticking);
    });
};
//# sourceMappingURL=doneTick.js.map